import AREAS from './areas'
import CATEGORIA from './categoria'
import { EmisionResultadoC3Notification } from './EmisionResultadoC3Notification'
import PRIORIDAD from './prioridad'
import { RegistroMovimientoArmaNotification } from './RegistroMovimientoArmaNotification'
import { CalificacionCursoNotification } from './CalificacionCursoNotification'
import { CambioEstatusNotification } from './CambioEstatusNotification'
import { CambioTipoPuestoNotification } from './CambioTipoPuestoNotification'
import { CambioEvaluacionDesempeñoNotification } from './CambioEvaluacionDesempeñoNotification'
import { CambioEvaluacionDesempeñoAcademicoNotification } from './CambioEvaluacionDesempeñoAcademicoNotification'
import { RegistroCuipNotification } from './RegistroCuipNotification'

export const NOTIFICATION_TYPES = {
  REGISTRO_MOVIMIENTO_ARMA: 'REGISTRO_MOVIMIENTO_ARMA',
  EMISION_RESULTADO_C3: 'EMISION_RESULTADO_C3',
  CALIFICACION_CURSO: 'CALIFICACION_CURSO',
  CAMBIO_ESTATUS: 'CAMBIO_ESTATUS',
  CAMBIO_TIPO_PUESTO: 'CAMBIO_TIPO_PUESTO',
  CAMBIO_EVALUACION_DESEMPENO: 'CAMBIO_EVALUACION_DESEMPENO',
  CAMBIO_EVALUACION_DESEMPENO_ACADEMICO: 'CAMBIO_EVALUACION_DESEMPENO_ACADEMICO',
  REGISTRO_CUIP: 'REGISTRO_CUIP',
}

export class NotificationFactory {
  #notification
  #notificationCreators

  constructor(notification) {
    this.#notification = notification

    this.#notificationCreators = {
      [NOTIFICATION_TYPES.REGISTRO_MOVIMIENTO_ARMA]: new RegistroMovimientoArmaNotification(notification),
      [NOTIFICATION_TYPES.EMISION_RESULTADO_C3]: new EmisionResultadoC3Notification(notification),
      [NOTIFICATION_TYPES.CALIFICACION_CURSO]: new CalificacionCursoNotification(notification),
      [NOTIFICATION_TYPES.CAMBIO_ESTATUS]: new CambioEstatusNotification(notification),
      [NOTIFICATION_TYPES.CAMBIO_TIPO_PUESTO]: new CambioTipoPuestoNotification(notification),
      [NOTIFICATION_TYPES.CAMBIO_EVALUACION_DESEMPENO]: new CambioEvaluacionDesempeñoNotification(notification),
      [NOTIFICATION_TYPES.CAMBIO_EVALUACION_DESEMPENO_ACADEMICO]: new CambioEvaluacionDesempeñoAcademicoNotification(
        notification
      ),
      [NOTIFICATION_TYPES.REGISTRO_CUIP]: new RegistroCuipNotification(notification),
    }
  }

  createNotification(type, args) {
    const creator = this.#notificationCreators[type]

    if (!creator) {
      throw new Error(`Tipo de notificación desconocido: ${type}`)
    }

    return creator.create(args)
  }
}
